import React from 'react';
import ReactDOM from 'react-dom/client';

// Design system — порядок важен
import './styles/tokens.css';
import './styles/reset.css';
import './styles/typography.css';
import './styles/animations.css';
import './styles/components.css';

import App from './app/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);